export default __webpack_public_path__ + "static/media/369.0c3dc446.png";